import { Radio } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const OnlineIcon = createLucideIcon(Radio);
